<style scoped lang="scss">
.state {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/wo/pageForPlan" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item class="noborder" :label="$t('jihuadanhao')">
            <el-input disabled v-model="$attrs.work.no"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('jihuashuliang')">
            <el-input disabled v-model="$attrs.work.quantity"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('yipaichanshuliang')">
            <el-input disabled v-model="$attrs.work.schedulingQuantity"></el-input>
          </el-form-item>

          <yi_curd_expand_button></yi_curd_expand_button>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->

      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!--        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="exportExcel()"></el-button>-->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <!-- 状态  1新建、2发放、3生产中、4暂停、5首工序完工、6完工、7关闭、8已调拨  -->
          <el-col :span="0.1">
            <el-button v-if="scope.row.status == 1" type="text" @click="giveOut(scope.row)">{{ $t('fafang') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button :loading="plan_work_order_close_loading" v-if="scope.row.status == 1 || scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 2" type="text" class="font-color-danger" @click="close(scope.row)">{{ $t('guanbi') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="scope.row.status == 2 || scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 6 || scope.row.status == 5 || scope.row.status == 7" type="text" @click="yt.showEditDialog('gongxugongdan', scope.row, '900px')">{{ $t('gongxugongdan') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog v-dialog-drag :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 工序工单 -->
      <!--      :chart="yt.editObj"-->
      <template v-if="yt.editObj.action == 'gongxugongdan'">
        <div class="dialog-scroller">
          <process :processWork="yt.editObj" :work="$attrs.work"></process>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import process from '@@/pages/web/order_management/production_plan_customized/work_order/process'

export default {
  name: 'web_order_management_production_plan_customized_work_order_list',
  components: {
    process
  },
  data() {
    return {
      plan_work_order_close_loading: false,
      status: [{
        label: this.$t('xinjian'),
        value: 1
      },
      {
        label: this.$t('fafang'),
        value: 2
      },
      {
        label: this.$t('shengchanzhong'),
        value: 3
      },
      {
        label: this.$t('zanting'),
        value: 4
      },
      {
        label: this.$t('shougongxuwangong'),
        value: 5
      },
      {
        label: this.$t('wangong'),
        value: 6
      },
      {
        label: this.$t('guanbi'),
        value: 7
      },
      {
        label: this.$t('yidiaobo'),
        value: 8
      }
      ],
      columns: [{
        label: 'shengchangongdanhao',
        prop: 'no',
        width: 130,
      }, {
        label: 'shebeimingcheng',
        prop: 'equipment.name',
        width: 130,
      }, {
        label: 'mujubianhao',
        prop: 'mould.no',
        width: 130,
      }, {
        label: 'mujumingcheng',
        prop: 'mould.name',
        width: 130,
      }, {
        label: 'chanpinbianma',
        prop: 'material.code',
        width: 130,
      }, {
        label: 'chanpinmingcheng',
        prop: 'material.name',
        width: 130,
      },
      {
        label: 'jihuashuliang',
        prop: 'planQuantity',
      },
      {
        label: 'shengchanshuliang',
        prop: 'productionQuantity',
        width: 130,
      }, {
        label: 'yibaogongliangpinshu',
        prop: 'finishGoodQuantity',
        width: 130,
      },

      {
        label: 'yibaogongbuliangpinshu',
        prop: 'finishBadQuantity',
        width: 130,
      },
      {
        label: 'guishuchejian',
        prop: 'org.name',
        width: 130,
      },
      {
        label: 'gongdanzhuangtai',
        type: 'tag',
        prop: 'status',
        tags: {
          1: {
            color: '#419FFF',
            text: this.$t('xinjian')
          },
          2: {
            color: '#419FFF',
            text: this.$t('fafang')
          },
          3: {
            color: '#67C23A',
            text: this.$t('shengchanzhong')
          },
          4: {
            color: '#F56C6C',
            text: this.$t('zanting')
          },
          5: {
            color: '#67C23A',
            text: this.$t('shougongxuwangong')
          },
          6: {
            color: '#67C23A',
            text: this.$t('wangong')
          },
          7: {
            color: '#909399',
            text: this.$t('guanbi')
          },
          8: {
            color: '#E6A23C',
            text: this.$t('yidiaobo')
          }
        },
      },

      {
        label: 'gongdanshunxu',
        prop: 'priority',
        width: 130,
      },
      {
        label: 'jihuakaishishijian',
        prop: 'planStartTime',
        type: 'time',
        width: 180,
        // format: 'yyyy-MM-dd:hh:mm:ss'
      },
      {
        label: 'jihuawanchengshijian',
        prop: 'planEndTime',
        type: 'time',
        width: 180,
        // format: 'yyyy-MM-dd:hh:mm:ss'
      },
      {
        label: 'shijikaishishijian',
        prop: 'actualStartTime',
        type: 'time',
        width: 180,
        // format: 'yyyy-MM-dd:hh:mm:ss'
      },
      {
        label: 'shijiwanchengshijian',
        prop: 'actualEndTime',
        type: 'time',
        width: 180,
        // format: 'yyyy-MM-dd:hh:mm:ss'
      },
      {
        label: 'beizhu',
        prop: 'remark',
        width: 130,
      },
      {
        label: 'gongyizhinanbianma',
        prop: 'craftGuide.code',
        // type: 'slot',
        width: 130,
      },

      {
        label: 'caozuo',
        type: 'slot',
        width: 250,
        fixed: 'right'
      }
      ],
    };
  },
  filters: {
    getCode(value) {
      if (value != null) {
        return value.map(item => {
          return item.procedureCode
        }).join(",")
      }
      return '';
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        planId: this.$attrs.work.id,
        // orderBy: 'planStartTime,equipmentId asc',
      }
      this.yt.get(1);

      // this.yt.list = []
      // this.utils.event_hub.$on('PRODUCTION_MANAGEMENT_REFRESH', () => {
      // 	this.yt.get();
      // })
    }, 300)

  },
  methods: {
    refresh() {
      this.yt.get(1);
      this.utils.event_hub.$emit('ORDER_MANAGEMENT_REFRESH');
    },
    // 发放
    giveOut(row) {
      return this.http.post('/web/production/wo/giveOut', row.id).then(res => {
        this.refresh()
        this.$message.success(this.$t(res.msg))
      }).catch(error => {
        this.$message.error(this.$t(error))
      })
    },
    // 关闭
    close(row) {
      this.plan_work_order_close_loading = true;
      return this.http.post('/web/production/wo/close', {
        id:row.id
      }).then(res => {
        this.refresh()
        this.$message.success(this.$t(res.msg))
      }).catch(error => {
        this.$message.error(this.$t(error))
      }).finally(() => {
        this.plan_work_order_close_loading = false;
      })
    },
    exportExcel() {
      let params = {
        ...this.yt.conditions,
        pageNum: 1,
        pageSize: 999
      }
      delete params.orderBy
      // let params = this.yt.conditions
      return this.http.get('/web/report/export/production_wo_report', {
        params
      }).then(res => {
        this.$message.success(this.$t(res.msg))
        this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
      }).catch(error => {
        this.$message.error(this.$t(error))
      })
    },
    // 重置
    clear() {
      this.yt.conditions = {
        createTimeStart: this.begin(),
        createTimeEnd: this.end()
      }
      this.yt.list = []
    },
  },
};
</script>
